import { IS_EYEJACK_APP } from "@webcore/core/utils/utils";

export type TDevice =
  | 'iOS'
  | 'Mac OS'
  | 'Windows'
  | 'Android'
  | 'Linux'
  | 'AppClip';

let device: TDevice;

const getUserDevice = () => {
  const { userAgent } = navigator;

  const platform = window.navigator.platform;
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'];

  if (IS_EYEJACK_APP) {
    device = 'AppClip';
  } else if (macosPlatforms.indexOf(platform) !== -1) {
    //ipad pro get reported as MacIntel
    if (
      platform === 'MacIntel' &&
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2
    )
     device = 'iOS';
    else device = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    device = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    device = 'Windows';
  } else if (/Android/.test(userAgent)) {
    device = 'Android';
  } else if (!device && /Linux/.test(platform)) {
    device = 'Linux';
  }

  return {
    device,
    isMobile: device === 'iOS' || device === 'Android' || device === 'AppClip',
  };
};

export default getUserDevice;
